require("././animate.css");


//////////////////
// WEBPACK FOOTER
// animate.css (bower component)
// module id = 1201
// module chunks = 0